export default "__VITE_ASSET__mKAV33Y9__"